import { defineStore } from "pinia";
import authApi from "../../api/authApi";
import { useNotificationStore } from "./notification";
// import Swal from "sweetalert2";
// import router from "../../router"; 

const STORAGE_ACCESS_TOKEN = 'accessToken';
const STORAGE_USER_INFO = 'userInfo';

export const useAuthStore = defineStore("auth", {
  state: () => ({
    token: null,
    tokenType: null,
    username: null,
    user_id: null,
    name: null,
    roleId: null,
  }),
  getters: {
    getUserId(state) {
      return state.user_id || "";
    },
    getName(state) {
      return state.name || "";
    },
    getUserRole(state) {
      return state.roleId || "";
    },
    getToken(state) {
      return state.token && state.tokenType ? `${state.tokenType} ${state.token}` : "";
    },
    loggedIn(state) {
      return !!state.token;
    }
  },
  actions: {
    async login(email, password) {
      try {
        const user = await authApi.login(email, password)

        this.setUser(user);
        this.saveState(user);
        this.saveStateUserInfo(user);

        const notificationStore = useNotificationStore();
        notificationStore.success('Sukses Login');

        return Promise.resolve(user);
      } catch (error) {
        return Promise.reject(error);
      }
    },
    setUser(user) {
      if (user && typeof user === 'object') {
        this.token = user.token || null;
        this.tokenType = user.tokenType || null;
        this.username = user.username || null;
      } else {
        this.token = null;
        this.tokenType = null;
        this.username = null;
      }
    },
    saveState(user) {
      if (user && user.token) {
        const data = {
          token: user.token,
          tokenType: user.tokenType,
          username: user.username,
          expiresIn: user.expiresIn,
        }
        window.localStorage.setItem(STORAGE_ACCESS_TOKEN, JSON.stringify(data))
      } else {
        window.localStorage.removeItem(STORAGE_ACCESS_TOKEN)
      }
    },
    async saveStateUserInfo(user) {
      if (user && user.token) {
        const userInfo = await authApi.getUserInfo(user.token, user.username)
        const data = {
          created_at: userInfo.createdAt,
          email: userInfo.email,
          id: userInfo.id,
          name: userInfo.name,
          role_id: userInfo.roleId,
          username: userInfo.username,
        }
        this.user_id = userInfo.id || null;
        this.name = userInfo.name || null;
        this.roleId = userInfo.roleId || null;
        window.localStorage.setItem(STORAGE_USER_INFO, JSON.stringify(data))
      } else {
        window.localStorage.removeItem(STORAGE_USER_INFO)
      }
    },
    loadState() {
      try {
        // load access token
        const data = window.localStorage.getItem(STORAGE_ACCESS_TOKEN);
        if (!data) {
          this.setUser(null);
          return;
        }
        const user = JSON.parse(data);
        if (user && user.token) {
          this.setUser(user);
        } else {
          this.setUser(null);
        }

        // load user info
        const userInfoData = window.localStorage.getItem(STORAGE_USER_INFO);
        if (userInfoData) {
          const userInfo = JSON.parse(userInfoData);
          this.user_id = userInfo.id || null;
          this.name = userInfo.name || null;
          this.roleId = userInfo.role_id || null;
        }
      } catch (e) {
        this.setUser(null);
        this.user_id = null;
        this.name = null;
        this.roleId = null;
      }
    },
    async refreshUserInfo() {
      if (this.token && this.username) {
        const userInfo = await authApi.getUserInfo(this.token, this.username)
        const data = {
          created_at: userInfo.createdAt,
          email: userInfo.email,
          id: userInfo.id,
          name: userInfo.name,
          role_id: userInfo.roleId,
          username: userInfo.username,
        }
        this.user_id = userInfo.id || null;
        this.name = userInfo.name || null;
        this.roleId = userInfo.roleId || null;
        window.localStorage.setItem(STORAGE_USER_INFO, JSON.stringify(data))
      }
    },
    // checkSession() {
    //   const accessToken = localStorage.getItem("accessToken");
    //   if (accessToken) {
    //     const parsedToken = JSON.parse(accessToken);
    //     const now = new Date();
    //     const expired = new Date(parsedToken.expiresIn);

    //     if (now > expired) {
    //       Swal.fire({
    //         icon: "warning",
    //         title: "Sesi Berakhir",
    //         text: "Silakan login kembali.",
    //         confirmButtonText: "OK",
    //       }).then(() => {
    //         this.logout();
    //         return router.push("/login");
    //       });
    //     }
    //   }
    // },
    // checkSession() {
    //   const accessToken = localStorage.getItem("accessToken");
    //   if (accessToken) {
    //     const parsedToken = JSON.parse(accessToken);
    //     const now = new Date();
    //     const expired = new Date(parsedToken.expiresIn);

    //     if (now > expired) {
    //       return false;
    //     } else {
    //       return true;
    //     }
    //   }
    // },

    logout() {
      this.setUser(null);
      window.localStorage.removeItem(STORAGE_ACCESS_TOKEN);
      window.localStorage.removeItem(STORAGE_USER_INFO);
    }
  },
})
